/* eslint-disable */
const mutations = {
  updateIsLoading(state, { isLoading }) {
    state.isLoading = isLoading;
  },

  setTag(state, { tag }) {
    state.data = tag;
  },

  updateTag(state, { tag }) {
    state.data = {
      ...state.data,
      ...tag,
    };
  },
};

export default mutations;
